var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckedHomeStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCheckedHomeStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6215385,20.72 C10.4738462,20.576 10.4,20.36 10.4,20.216 C10.4,20.072 10.4738462,19.856 10.6215385,19.712 L11.6553846,18.704 C11.9507692,18.416 12.3938462,18.416 12.6892308,18.704 L12.7630769,18.776 L16.8246154,23.024 C16.9723077,23.168 17.1938462,23.168 17.3415385,23.024 L27.2369231,13.016 L27.3107692,13.016 L27.3107692,13.016 C27.6061538,12.728 28.0492308,12.728 28.3446154,13.016 L29.3784615,14.024 C29.6738462,14.312 29.6738462,14.744 29.3784615,15.032 L29.3784615,15.032 L17.5630769,26.984 C17.4153846,27.128 17.2676923,27.2 17.0461538,27.2 C16.8246154,27.2 16.6769231,27.128 16.5292308,26.984 L10.7692308,20.936 L10.6215385,20.72 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends-request-Accepted",
    transform: "translate(-327.000000, -255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/User-FriendRequest-Fullpage-Copy",
    transform: "translate(0.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(317.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCheckedHomeStream",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckedHomeStream);
export default __webpack_public_path__ + "static/media/icCheckedHomeStream.f3bd77d9c73fa2da68371a4aebe76372.svg";
export { ForwardRef as ReactComponent };